import request from '~/utils/http';
// 客户信息
export function getUser() {
  return request({
    url: 'api/FrontUser/GetUserInfo',
    method: 'post',
    data: {}
  })
}

// 协议
export function getContract() {
  return request({
    url: 'api/ClientContract/Get',
    method: 'post',
    data: {}
  })
}

// 收货地址
export function getAddress(data) {
  return request({
    url: 'api/ShippingAddress/GetList',
    method: 'post',
    data: data
  })
}

// 业务员
export function getSalesMan(data) {
  return request({
    url: 'api/ClientSales/GetList',
    method: 'post',
    data: data
  })
}

// 消息列表
export function getMessage() {
  return request({
    url: 'api/MesSendConfig/GetContentList',
    method: 'post',
    data:{}
  })
}

// 消息定制
export function getCustomMessage() {
  return request({
    url: 'api/MesSendConfig/GetList',
    method: 'post',
    data: {}
  })
}
